import { render, staticRenderFns } from "./FirstRidePax.vue?vue&type=template&id=6f6c0802&scoped=true"
import script from "./FirstRidePax.vue?vue&type=script&lang=js"
export * from "./FirstRidePax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6c0802",
  null
  
)

export default component.exports